import {
  PLAY_VIDEO,
  SHARE_SPY_ROLE,
  CLICK_COMPARISON_INVITE_BUTTON,
  COPY_COMPARISON_INVITE_URL,
  SHARE_COMPARISON_INVITE_URL,
  SHOW_DOSSIER_PURCHASE_MODAL,
  BEGIN_DOSSIER_PURCHASE,
  SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL,
} from './action-types';

export const playVideoAction = ({ eventTarget, eventId }) => ({
  type: PLAY_VIDEO,
  payload: {
    eventId,
    eventTarget,
  },
});

export const shareSpyRoleAction = ({ spyRole, socialNetwork }) => ({
  type: SHARE_SPY_ROLE,
  payload: {
    spyRole,
    socialNetwork,
  },
});

export const clickComparisonInviteButtonAction = ({ profileId }) => ({
  type: CLICK_COMPARISON_INVITE_BUTTON,
  payload: { profileId },
});

export const copyComparisonInviteUrlAction = ({ profileId }) => ({
  type: COPY_COMPARISON_INVITE_URL,
  payload: { profileId },
});

export const shareComparisonInviteUrlAction = ({
  profileId,
  socialNetwork,
}) => ({
  type: SHARE_COMPARISON_INVITE_URL,
  payload: {
    profileId,
    socialNetwork,
  },
});

export const showDossierPurchaseModalAction = () => ({
  type: SHOW_DOSSIER_PURCHASE_MODAL,
  payload: {},
});

export const beginDossierPurchaseAction = ({
  eventCallback,
  eventTimeout,
}) => ({
  type: BEGIN_DOSSIER_PURCHASE,
  payload: { eventCallback, eventTimeout },
});

export const showDossierPurchaseSuccessModalAction = () => ({
  type: SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL,
  payload: {},
});
